// React imports
import React from 'react';
import { commonEnums } from '@codametrix/ui-common';
import classNames from 'classnames';
import { Icon } from '@codametrix/ui-components';

const { CaseAlertType } = commonEnums;
const DEFAULT_PROPS: Partial<Accelerate.CaseAlertProps> = {
  alertSize: 'md'
};

const alertIcon = {
  [CaseAlertType.WARNING]: 'BiomeWarning',
  [CaseAlertType.ERROR]: 'BiomeWarning',
  [CaseAlertType.INFO]: 'BiomeInfo'
} as const;
class CaseAlert extends React.Component<Accelerate.CaseAlertProps> {
  /**
   * Constructor method for class CaseAlert
   * @param {Accelerate.CaseAlertProps} props - Props object passed to CaseAlert component
   */
  constructor(props: Accelerate.CaseAlertProps) {
    super(props);
  }

  render() {
    const props = {
      ...DEFAULT_PROPS,
      ...this.props
    };

    const caseAlertClass = [
      'case-alert',
      'case-alert-' + props.alertSize,
      {
        'case-alert-warning': this.props.alertType === CaseAlertType.WARNING,
        'case-alert-error': this.props.alertType === CaseAlertType.ERROR,
        'case-alert-info': this.props.alertType === CaseAlertType.INFO
      }
    ];

    const caseAlertSidebar = [
      'case-alert-sidebar',
      {
        'case-alert-bg-warning': this.props.alertType === CaseAlertType.WARNING,
        'case-alert-bg-error': this.props.alertType === CaseAlertType.ERROR,
        'case-alert-bg-info': this.props.alertType === CaseAlertType.INFO
      }
    ];
    const alertIconClass = [
      {
        'case-alert-icon-warning':
          this.props.alertType === CaseAlertType.WARNING,
        'case-alert-icon-error': this.props.alertType === CaseAlertType.ERROR,
        'case-alert-icon-info': this.props.alertType === CaseAlertType.INFO
      }
    ];

    return (
      <div className={classNames(caseAlertClass)} data-testid="case-alert">
        <div className={classNames(caseAlertSidebar)}>
          <Icon
            svgIconName={alertIcon[this.props.alertType]}
            svgIconClass={classNames(alertIconClass)}
            svgIconSize="20"
          />
        </div>
        <div>{this.props.children}</div>
      </div>
    );
  }
}

export { CaseAlert };
